import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import invitationsApi from '@/features/dashboard/invitations/api/invitationsApi.ts';
import { invitationsApiQueryKeys } from '@/features/dashboard/invitations/api/invitationsApi.queryKeys.ts';
import { CreateInvitationDto } from '@/features/dashboard/invitations/types/CreateInvitationDto.ts';
import { InvitationDto } from '@/features/dashboard/invitations/types/InvitationDto.ts';

const useCreateInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation<InvitationDto, Error, CreateInvitationDto>({
    mutationFn: (data) => invitationsApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: invitationsApiQueryKeys.all(),
      });
      toast.success('Zaproszenie zostało wysłane');
    },
    onError: (error) => {
      toast.error('Wystąpił błąd', {
        description: error.message,
      });
    },
  });
};

export default useCreateInvitation;
